import { render, staticRenderFns } from "./new-homework.vue?vue&type=template&id=14391bda&"
import script from "./new-homework.vue?vue&type=script&lang=js&"
export * from "./new-homework.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports